import { ICommunity, IListingTypeID, IMHBOListing } from 'mhbo-js'
import React from 'react'
import { FormattedNumber, IntlProvider } from 'react-intl'
import { Col, Row } from 'reactstrap'
import NO_PHOTO from '../../../assets/no_photo.png'
import FavoriteIcon from './FavoriteIcon'
import Flags from './Flags'

interface IProps {
  communityListing: ICommunity
  onClick: () => void
  onMouseOver?: () => void
  onMouseOut?: () => void
  isFavorite: boolean
  favid: number
  isLazy: boolean
}

const CommunityPreviewCell: React.FC<IProps> = (props: IProps) => {
  const {
    communityListing,
    onMouseOver,
    onClick,
    isFavorite,
    favid,
    onMouseOut,
    isLazy,
  } = props
  const {
    address,
    photoLarge,
    name,
    minSalePrice,
    mobilehomes,
    ageRestrictionType,
    withPetFriendly,
    isResidentOwned,
    isMhrv,
    id,
  } = communityListing
  const forSaleHomes = mobilehomes
    ? mobilehomes.filter(
        (home: IMHBOListing) =>
          home.listingTypeId &&
          [
            IListingTypeID.ForSale,
            IListingTypeID.ForRentAndToOwn,
            IListingTypeID.ForRentOrForSale,
          ].includes(home.listingTypeId)
      ).length
    : 0
  const forRentHomes = mobilehomes
    ? mobilehomes.filter(
        (home: IMHBOListing) =>
          home.listingTypeId &&
          [
            IListingTypeID.ForRent,
            IListingTypeID.ForRentAndToOwn,
            IListingTypeID.ForRentOrForSale,
          ].includes(home.listingTypeId)
      ).length
    : 0
  const photo = photoLarge === '' ? NO_PHOTO : photoLarge
  return (
    <IntlProvider locale="en">
      <div
        className="listingCell__preview_cell"
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
        onClick={onClick}
      >
        <img
          alt=""
          src={photo}
          className="listingCell__preview_cell_image"
          loading={isLazy ? 'lazy' : 'eager'}
        />
        <div className="listingCell__preview_cell_header">
          <Flags
            isCommunity={true}
            ageRestrictionType={ageRestrictionType}
            withPetFriendly={withPetFriendly}
            isResidentOwned={isResidentOwned}
            isMhrv={isMhrv}
          />
          <FavoriteIcon
            isFavorite={isFavorite}
            id={id}
            type="Community"
            favid={favid}
          />
        </div>

        <div className="listingCell__preview_cell_footer_white">
          <Row className="align-items-center">
            {minSalePrice !== 0 ? (
              <Col xs={5}>
                <div className="listingCell__price_container">
                  <p className="listingCell__price_heading">{`Homes from`}</p>
                  <p className="listingCell__price_number">
                    {minSalePrice ? (
                      <FormattedNumber
                        // eslint-disable-next-line react/style-prop-object
                        style="currency"
                        currency="USD"
                        currencyDisplay="symbol"
                        value={minSalePrice}
                        minimumFractionDigits={0}
                      />
                    ) : null}
                  </p>
                </div>
              </Col>
            ) : null}
            <Col xs={minSalePrice !== 0 ? 7 : 12}>
              <>
                <p className="listingCell__footer_content_navy_right">
                  {forSaleHomes > 0 ? (
                    <>
                      <span className="listingCell__footer_content_bold">
                        {forSaleHomes}
                      </span>
                      {` For Sale `}
                    </>
                  ) : null}

                  {forSaleHomes > 0 && forRentHomes > 0 ? ` | ` : null}
                  {forRentHomes > 0 ? (
                    <>
                      <span className="listingCell__footer_content_bold">
                        {forRentHomes}
                      </span>
                      {` For Rent `}
                    </>
                  ) : null}
                </p>
                <p className="listingCell__footer_content_navy_right">{`${address.city}, ${address.state}`}</p>
                <p className="listingCell__community_link">
                  {minSalePrice && name.length > 22
                    ? `${name.substring(0, 22)}...`
                    : name}
                </p>
              </>
            </Col>
          </Row>
        </div>
      </div>
    </IntlProvider>
  )
}

export default CommunityPreviewCell
